import clsx from 'clsx';
import { useHistory, useLocation } from 'react-router-dom';

import {
  AppBar as MUIAppBar,
  Toolbar,
  IconButton,
  Divider,
  Typography,
  Button,
  useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

// import MoneyDropDown from '../MoneyDropDown';
// import LanguageDropDown from '../LanguageDropDown';

import { useAppBar } from './hook';
import { useTranslation } from 'core/contexts/localization';
import { ROUTES } from 'core/routing/routes';


const AppBar = ({ toggleMenu, open, isHome }) => {
  
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const { t: translate } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const { classes, role, setRole, onBecomeClick } = useAppBar(isHome);
  
  const drawerWidth = isMobile ? '100vw' : 240;

  const appBarShiftStyles = open ? {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: (theme) => theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
  } : {};

  return (
    (<MUIAppBar
      elevation={0}
      className={clsx(classes.appBar)}
      style={appBarShiftStyles}>
      <div className={`${classes.toolbar}`}>
        {isMobile ? (
          <IconButton
            color="white"
            onClick={toggleMenu}
            edge="start"
            className={classes.menuButton}
            size="large">
            <MenuIcon />
          </IconButton>
        ) : null}
      </div>
    </MUIAppBar>)
  );
};

AppBar.displayName = 'AppBar';

export default AppBar;
